import React from 'react'
import { Paper, Typography, Button, CircularProgress } from '@mui/material'

const PRICE = 7

function ShareRegistryInfo({ onSubmit, saving }) {
  return (
    <div>
      <Typography variant='h4'>Osakerekisteri</Typography>
      <Paper style={{ margin: 20, padding: 20 }}>
        <Typography
          variant='body1'
          style={{ marginBottom: 25 }}
          component={'p'}
        >
          Osakerekisterillä hallitset yhtiösi osakkeita, osakkeenomistajia ja
          osakekauppoja. Voit luoda osakelajeja, osakepohjia ja luoda osakkeita
          erissä. Osakkeiden omistajuus siirretään kirjaamalla kauppoja.
        </Typography>
        <Typography
          variant='body1'
          style={{ marginBottom: 25 }}
          component={'p'}
        >
          Ominaisuudet:
        </Typography>
        <ul style={{ marginBottom: 25 }}>
          <li>Osakelajien ja osakepohjien hallinta</li>
          <li>Osakkeiden luonti erissä</li>
          <li>Osakkeenomistajien hallinta</li>
          <li>Osakekauppojen kirjaus ja seuranta</li>
          <li>Äänimäärien laskenta</li>
          <li>CSV-vienti</li>
        </ul>
        <Typography
          variant='body1'
          style={{ marginBottom: 30 }}
          component={'p'}
        >
          Voit ottaa ominaisuuden käyttöön tästä. Voit kokeilla ominaisuutta 2 viikkoa jonka jälkeen kuukausimaksuun lisätään 7€.
        </Typography>
        <Button
          disabled={saving}
          variant='contained'
          color='primary'
          onClick={() => onSubmit(PRICE)}
        >
          {saving ? <CircularProgress size={25} color='info' /> : 'Ota käyttöön'}
        </Button>
      </Paper>
    </div>
  )
}

export default ShareRegistryInfo
